import contact from './contact'
import maxLength from './maxLength'
import maxValue from './maxValue'
import minLength from './minLength'
import maxByteLength from './maxByteLength'
import minValue from './minValue'
import name from './name'
import network from './network'
import number from './number'
import password from './password'
import required from './required'

export default {
  install (Vue) {
    Vue.prototype.$valid = Object.assign({}, contact, maxLength, maxValue, minLength, maxByteLength, minValue, name, network, number, password, required)
  }
}
